module.exports = __webpack_public_path__ + "media/images/icon__reddit@3x-53b96a01b60b639ebc78c164cf30deee.png";